import React, {Component} from 'react';
import {IProps, IState} from "./types";
import Sidebar from "../../containers/Sidebar";
import Chat from "../../containers/Chat";
import MessageSound from "../../components/SoundsController/MessageSound";
import {chatMessage, chatMessageUpdate} from "../../utils/api/subscribe";
import * as Notification from '../../components/Notification'
import * as Scroll from 'react-scroll';
import {prepareAttachment} from "../../controllers/attachment";
import moment from "moment";
import I18n from "i18next";
import {connect} from "react-redux";
import {REDUCER_TYPE} from "../../modules/Reducer";
import {
    AttachmentsUpdate,
    MessagesUpdate,
    UpdateUnreadMessage,
    ChatMessagesUpdate,
    UpdateUnreadPrivateChats,
    UpdateUnreadGroupChat
} from "../../modules/Actions";
import {withTranslation} from "react-i18next";
import { Message, ModuleValues } from "../../types";

// eslint-disable-next-line @typescript-eslint/no-unused-vars

class Authorized extends Component <IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            chosenModule: 'video',
            channelId: props.channelId,
            messages: props.messages,
            chatMessages: props.chatMessages || {},
            attachments: props.attachments||null,
            loggedData: props.loggedData,
            newMessage: false,
            selectedChat: props.selectedChat || 'group',
        };

        this.catchNewMessage();
        this.catchUpdateMessage();
    }

    componentDidMount(): void {
        try {
            const params = new URLSearchParams(window.location.search);
            if (params.get('upload') === '1') {
              this.setState({chosenModule: ModuleValues.UPLOAD});
            }
        } catch (e) {
            // no-op
        }
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        if (
            this.props.messages !== prevProps.messages
            || this.props.attachments !== prevProps.attachments
            || this.props.loggedData !== prevProps.loggedData
            || this.props.chatMessages !== prevProps.chatMessages
            || this.props.selectedChat !== prevProps.selectedChat
        ) {
            this.setState({
                messages: this.props.messages,
                chatMessages: this.props.chatMessages || {},
                attachments: this.props.attachments || null,
                loggedData: this.props.loggedData,
                selectedChat: this.props.selectedChat || 'group',
            })
        }
    }

    changeModule = (value: string) => {
        this.setState({
            chosenModule: value
        });

        let message_input = document.getElementById("messageInput");

        setTimeout(() => {
            this.scrollMessageList();
        }, 300);

        if (message_input) {
            message_input.focus();
        }
    };

    catchNewMessage = () => {
        chatMessage((data: any) => {
            const privateChatKey = this.getPrivateChatKey(data.message);
            if (privateChatKey) {
                this.addPrivateMessage(data.message, privateChatKey);
                this.controlNotifications(data.message);
                this.markUnreadPrivateChat(privateChatKey, data.message);
                if (data.message.participant.uuid !== this.state.authUser?.uuid) {
                    const messageContainer = document.getElementById('messagesList');
                    let isVisible = false;
                    if (messageContainer) {
                        const rect = messageContainer.getBoundingClientRect();
                        const viewHeight = window.innerHeight || document.documentElement.clientHeight;
                        const viewWidth = window.innerWidth || document.documentElement.clientWidth;
                        isVisible = rect.width > 0 && rect.height > 0 && rect.top < viewHeight && rect.left < viewWidth && rect.bottom > 0 && rect.right > 0;
                    }
                    if (!isVisible) {
                        this.props.dispatch(UpdateUnreadMessage(+this.props.unreadMessage + 1));
                    }
                }
                return;
            }

            this.addMessage(data.message);
            this.markUnreadGroupChat(data.message);
            this.controlNotifications(data.message);
            if (data.message.participant.uuid === this.state.authUser?.uuid) {
                if (this.state.authUser?.role === 'User' && !this.state.loggedData.remoteUserActive) {
                    const message = {
                        content: I18n.t('warnings:doctorNotPresentWarning'),
                        createdAt: moment().format('YYYY-MM-DD HH:mm')
                    }
                    this.addMessage(message);
                    this.controlNotifications(data.message);
                    Notification.info(message.content)
                }
            }
        });
    };

    markUnreadPrivateChat = (chatKey: string, message: Message) => {
        if (!chatKey) {
            return;
        }

        if (message.participant?.uuid === this.props.authUser?.uuid) {
            return;
        }

        if (this.state.selectedChat === chatKey) {
            return;
        }

        const unreadPrivateChats = this.props.unreadPrivateChats || {};
        const updatedUnread = {
            ...unreadPrivateChats,
            [chatKey]: (unreadPrivateChats[chatKey] || 0) + 1
        };

        this.props.dispatch(UpdateUnreadPrivateChats(updatedUnread));
    };

    markUnreadGroupChat = (message: Message) => {
        if (message.participant?.uuid === this.props.authUser?.uuid) {
            return;
        }

        if (this.state.selectedChat === 'group') {
            return;
        }

        const currentUnread = this.props.unreadGroupChat || 0;
        this.props.dispatch(UpdateUnreadGroupChat(currentUnread + 1));
    };

    getPrivateChatKey = (message: any) => {
        if (!message) {
            return null;
        }

        if (!message.recipient?.uuid) {
            return null;
        }

        const authUuid = this.props.authUser?.uuid;
        if (authUuid && message.recipient.uuid === authUuid) {
            return message.participant?.uuid || null;
        }

        return message.recipient.uuid;
    };

    controlNotifications = (message: any) => {
        let list = document.getElementById('messagesList');
        if (list) {
            let height = list.scrollHeight - list.clientHeight;
            if (height - list.scrollTop > 300) {
                Notification.info(message.participant.name + ': ' + message.content)
            } else {
                this.scrollMessageList();
            }
        }

        if (this.props.authUser && message.participant.uuid !== this.props.authUser?.uuid) {
            this.setState({newMessage: true}, () => {
                setTimeout(() => {
                    this.setState({newMessage: false})
                }, 1000)
            })
        }
    };

    scrollMessageList = () => {
        Scroll.animateScroll.scrollToBottom({
            containerId: "messagesList",
            duration: 200,
        })
    };

    addMessage = (message: Message) => {
        let messages: any[] = [];
        if (this.state.messages) {
            messages = this.state.messages;
        }

        // @ts-ignore
        const createdAt = message.createdAt;

        if (createdAt) {
            const updatedCreated = moment(createdAt).add('2', "hour");
            message = {
                ...message,
                createdAt: updatedCreated.format()
            }
        }


        messages.push(message);
        this.setState({
            messages: messages
        });
        this.props.dispatch(MessagesUpdate(messages))
        this.addAttachment(message);

        if (message.participant?.uuid !== this.props.authUser?.uuid) {
          const messageContainer = document.getElementById('messagesList');
          let isVisible = false;
          if (messageContainer) {
            const rect = messageContainer.getBoundingClientRect();
            const viewHeight = window.innerHeight || document.documentElement.clientHeight;
            const viewWidth = window.innerWidth || document.documentElement.clientWidth;
            isVisible = rect.width > 0 && rect.height > 0 && rect.top < viewHeight && rect.left < viewWidth && rect.bottom > 0 && rect.right > 0;
          }
          if (!isVisible) {
            this.props.dispatch(UpdateUnreadMessage(+this.props.unreadMessage + 1));
          }
        }
        return false;
    };

    addPrivateMessage = (message: Message, participantUuid: string) => {
        const chatMessages = this.state.chatMessages ? {...this.state.chatMessages} : {};
        const existingMessages = chatMessages[participantUuid] ? [...chatMessages[participantUuid]] : [];

        // @ts-ignore
        const createdAt = message.createdAt;

        if (createdAt) {
            const updatedCreated = moment(createdAt).add('2', "hour");
            message = {
                ...message,
                createdAt: updatedCreated.format()
            }
        }

        existingMessages.push(message);
        chatMessages[participantUuid] = existingMessages;

        this.setState({
            chatMessages: chatMessages
        });
        this.props.dispatch(ChatMessagesUpdate(chatMessages))

        return false;
    };

    addAttachment = (message: any) => {
        if (!message.attachment) {
            return false;
        }

        let attachments: any[] = [];
        if (this.state.attachments) {
            attachments = this.state.attachments;
        }

        let attachment = prepareAttachment(message);

        attachments.push(attachment);

        this.setState({attachments: attachments});
        this.props.dispatch(AttachmentsUpdate(attachments))
    };

    catchUpdateMessage = () => {
        chatMessageUpdate((data: any) => {
            setTimeout(() => {
                this.updateMessage(data.message)
            }, 1000)
        })
    };

    updateMessage = (message: any) => {
        const privateChatKey = this.getPrivateChatKey(message);
        if (privateChatKey) {
            const chatMessages = this.state.chatMessages ? {...this.state.chatMessages} : {};
            const messages = chatMessages[privateChatKey];
            messages?.map((item, key) => {
                if (item.uuid === message.uuid) {
                    // @ts-ignore
                    messages[key] = message;
                }
                return item;
            });
            chatMessages[privateChatKey] = messages;
            this.setState({chatMessages});
            this.props.dispatch(ChatMessagesUpdate(chatMessages))
            return;
        }

        let messages = this.state.messages;
        messages?.map((item, key) => {
            if (item.uuid === message.uuid) {
                // @ts-ignore
                messages[key] = message;
            }
            return item;
        });
        this.props.dispatch(MessagesUpdate(messages))
        this.setState({messages: messages});
    };

    render() {
        return (<div className="authorized clear-space-sm">
            <Sidebar
                chosenModule={this.state.chosenModule}
                changeModule={this.changeModule}
                newMessage={this.state.newMessage}
            />
            <Chat
                messages={this.state.messages}
                chatMessages={this.state.chatMessages}
                chosenModule={this.state.chosenModule}
            />
            <MessageSound
                playMessage={this.state.newMessage}
                playCall={false}
            />
        </div>)
    }

}

const mapStateToProps = (state: REDUCER_TYPE) => {
    return state
}

// @ts-ignore
export default withTranslation()(connect(mapStateToProps)(Authorized))
